@for (subItem of mappedSubItems; track subItem.id) {
  <ion-item class="detail-list-item detail-list-item--{{subItem.id}}" lines="none"
    [ngClass]="{'detail-list-item--empty-icon': useIcon && !subItem.iconName }">
    @if (useIcon) {
      <ion-icon slot="start" color="primary" class="detail-list-item-icon"
        [name]="subItem.iconName || ''" aria-hidden="true"
        title="{{subItem.label | translate}}"/>
    }
    <ion-label class="detail-list-item-content">
      @if (useIcon && !inlineLabelFieldIds.includes(subItem.id)) {
        <span class="detail-list-item-label--hidden">{{ subItem.label | translate }}: </span>
      }
      @if (!useIcon) {
        <h3 class="detail-list-item-label">
          {{ subItem.label | translate }}:
        </h3>
      }
      @if (subItem.usesHtml) {
        <div class="detail-list-item-value" handle-links [innerHTML]="subItem.value"></div>
      } @else {
        <div class="detail-list-item-value">
          @if (inlineLabelFieldIds.includes(subItem.id)) {
            {{ subItem.label | translate }}:
          }
          {{ subItem.value }}
        </div>
      }
    </ion-label>
  </ion-item>
}
